export default "__VITE_ASSET__78a51876__"